import { Switch, Route, Redirect } from 'react-router-dom';
import React from 'react';
import loadRoute from 'launch/components/loadRoute';

const ProductPackagingDesign = ({ match, location }) => (
    <Switch>
        <Route
            path={`${match.url}/package-type`}
            component={loadRoute(done => require(['launch/components/BriefPackageType'], done))}
        />
        <Route
            path={`${match.url}/designs`}
            component={loadRoute(done => require(['launch/components/BriefStyleSelector'], done), {
                withStyleAssessment: false,
            })}
        />
        <Route
            path={`${match.url}/colors`}
            component={loadRoute(done => require(['launch/components/BriefStyleColors'], done))}
        />
        <Redirect from="*" to={{ ...location, pathname: `${match.url}/package-type` }} />
    </Switch>
);

export default ProductPackagingDesign;



// WEBPACK FOOTER //
// ./js/launch/routes/ProductPackagingDesign.jsx